import React from 'react';
import {
  Switch,
  BrowserRouter as Router,
  Route,
  Redirect
} from 'react-router-dom';
import ScrollToTop from './scroll-to-top';
import { Lookup, Choose, Create, Email, Thanks } from './steps';

const App = (props) => {
  return (
    <Router basename={props.slug}>
      <ScrollToTop>
        <Switch>
          {!props.hideLookupStep && (
            <Route
              exact
              path="/"
              render={(routeProps) => <Lookup {...routeProps} {...props} />}
            />
          )}
          {props.hideLookupStep && (
            <Route
              exact
              path="/"
              render={() => <Redirect push to="/choose" />}
            />
          )}
          <Route
            path="/choose"
            render={(routeProps) => <Choose {...routeProps} {...props} />}
          />
          <Route
            path="/create"
            render={(routeProps) => <Create {...routeProps} {...props} />}
          />
          <Route
            path="/email"
            render={(routeProps) => <Email {...routeProps} {...props} />}
          />
          <Route
            path="/thanks"
            render={(routeProps) => <Thanks {...routeProps} {...props} />}
          />
        </Switch>
      </ScrollToTop>
    </Router>
  );
};

export default App;
